import { styleConstants } from '@paywithextend/components'
import React from 'react'
import Tooltip from 'src/components/Tooltip/Tooltip'
import { useTranslate } from 'src/localization/Trns'
import { css } from 'styled-components'

interface ExpiresTooltipProps {
  openLeft: boolean
  className?: string
}

const ExpiresTooltip: React.FC<ExpiresTooltipProps> = (
  props,
): React.ReactElement => {
  const translate = useTranslate()

  return (
    <Tooltip openLeft={props.openLeft} className={props.className}>
      <p>
        {translate(
          '${expirationDate} is used when entering payment information. It is automatically set on card creation, and is unchangeable. ${itIsNot}',
          {
            expirationDate: (
              <span
                css={css`
                  font-family: ${styleConstants.fontFamilies.medium};
                `}
              >
                {translate('Expiration Date')}
              </span>
            ),
            itIsNot: (
              <span
                css={css`
                  font-family: ${styleConstants.fontFamilies.italic};
                `}
              >
                {translate(
                  "It is not the same as your card's Active Until Date, which determines how long your card is usable.",
                )}
              </span>
            ),
          },
        )}
      </p>
      <p
        css={css`
          margin-top: 12px;
        `}
      >
        {translate(
          'In the rare scenario where your card hits this expiration date, your card will be deactivated. You will need to request or create a new Virtual Card.',
        )}
      </p>
    </Tooltip>
  )
}

export default ExpiresTooltip
